<template>
  <b-row>
    <b-col cols="12" lg="12">
      <b-card
        :header="`Perfil de Acesso da ${company.fantasyName} - ${role.name}`"
        no-body
      >
        <b-card-body>
          <b-row>
            <b-col cols="3">
              <b-form-group label="Nome">
                <b-form-input v-model="role.name" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-card header="Módulos">
            <b-row>
              <b-col>
                <b-form-group label="Usuários">
                  <b-checkbox v-model="role.permissions.user.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.user.create"
                    >Criar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.user.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Empresa">
                  <b-checkbox v-model="role.permissions.company.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.company.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Questionários">
                  <b-checkbox v-model="role.permissions.questionnaire.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.questionnaire.create"
                    >Criar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.questionnaire.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Denúncias">
                  <b-checkbox v-model="role.permissions.complaint.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.complaint.readall"
                    >Ver tudo</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.complaint.edit"
                    >Editar</b-checkbox
                  >
                  <b-checkbox
                    v-model="role.permissions.complaint.managedByJoinCommittee"
                    >Participar do comitê das empresas gerenciadas</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Menções">
                  <b-checkbox v-model="role.permissions.mention.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.mention.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Dúvidas e Sugestões">
                  <b-checkbox v-model="role.permissions.qas.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.qas.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="LGPD">
                  <b-checkbox v-model="role.permissions.dsar.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.dsar.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Ouvidoria">
                  <b-checkbox v-model="role.permissions.ombudsman.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.ombudsman.edit"
                    >Editar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Relatórios">
                  <b-checkbox v-model="role.permissions.reports.read"
                    >Ver</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="GRC: Requisitos">
                  <b-checkbox v-model="role.permissions.requirements.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.requirements.create"
                    >Criar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.requirements.edit"
                    >Editar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.requirements.delete"
                    >Inativar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.requirements.approve"
                    >Aprovar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="GRC: Riscos">
                  <b-checkbox v-model="role.permissions.risks.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.risks.create"
                    >Criar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.risks.edit"
                    >Editar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.risks.delete"
                    >Inativar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.risks.approve"
                    >Aprovar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="GRC: Controles">
                  <b-checkbox v-model="role.permissions.controls.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.controls.create"
                    >Criar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.controls.edit"
                    >Editar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.controls.delete"
                    >Inativar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.controls.approve"
                    >Aprovar</b-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="GRC: Planos de Ação">
                  <b-checkbox v-model="role.permissions.actionPlans.read"
                    >Ver</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.actionPlans.create"
                    >Criar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.actionPlans.edit"
                    >Editar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.actionPlans.delete"
                    >Inativar</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.actionPlans.approve"
                    >Aprovar</b-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-card header="Relatórios">
            <b-row>
              <b-col>
                <b-form-group label="Denúncia">
                  <b-checkbox
                    v-model="role.permissions.reports.complaint.complaint"
                    >Denúncia</b-checkbox
                  >
                  <b-checkbox
                    v-model="role.permissions.reports.complaint.processing"
                    >Processamento</b-checkbox
                  >
                  <b-checkbox
                    v-model="role.permissions.reports.complaint.committee"
                    >Comitê</b-checkbox
                  >
                  <b-checkbox v-model="role.permissions.reports.complaint.audit"
                    >Auditoria</b-checkbox
                  >
                  <b-checkbox
                    v-model="role.permissions.reports.complaint.readall"
                    >Ver tudo</b-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-card-body>
        <b-card-footer>
          <b-button variant="primary" class="mr-2" @click="onSaveProfile"
            >Salvar</b-button
          >
          <b-button @click="$router.go(-1)">Cancelar</b-button>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { getCompany, getCompanyRole, editRole, newRole } from "@/api/company";

function createIfNull(obj, key, value = {}) {
  obj[key] = obj[key] || value;
}

export default {
  name: "EditAccessProfile",
  props: {
    companyId: {
      type: [Number, String],
      required: true,
    },
    roleId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      company: {},
      role: {
        permissions: {
          user: {},
          company: {},
          questionnaire: {},
          complaint: {},
          mention: {},
          qas: {},
          dsar: {},
          ombudsman: {},
          requirements: {},
          risks: {},
          controls: {},
          actionPlans: {},
          reports: {
            complaint: {},
          },
        },
      },
      data: [],
    };
  },
  async created() {
    await this.reloadData();
  },
  methods: {
    async reloadData() {
      let response = await getCompany(this.companyId);
      this.company = response.data;

      let role = {};

      if (this.roleId !== "novo") {
        response = await getCompanyRole(this.companyId, this.roleId);
        role = response.data;
        this.editing = true;
      }

      createIfNull(role, "permissions");
      createIfNull(role.permissions, "user");
      createIfNull(role.permissions, "company");
      createIfNull(role.permissions, "questionnaire");
      createIfNull(role.permissions, "complaint");
      createIfNull(role.permissions, "mention");
      createIfNull(role.permissions, "qas");
      createIfNull(role.permissions, "dsar");
      createIfNull(role.permissions, "ombudsman");
      createIfNull(role.permissions, "requirements");
      createIfNull(role.permissions, "risks");
      createIfNull(role.permissions, "controls");
      createIfNull(role.permissions, "actionPlans");
      createIfNull(role.permissions, "reports");
      createIfNull(role.permissions.reports, "complaint");
      this.role = role;
    },

    async onSaveProfile() {
      if (!this.role.name.trim()) return;

      this.loading = true;

      const action = this.editing ? editRole : newRole;

      await action(this.companyId, this.role);
      this.loading = false;

      this.$bvToast.toast(
        `Perfil ${this.editing ? "editado" : "criado"} com sucesso!`,
        {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        }
      );
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
